<div class="h-20 border-dashed text-primary-one flex items-center justify-center cursor-pointer relative appearance-none w-full text-sm placeholder-gray-400 rounded-lg bg-white px-4 py-3 border border-gray-200 transition-colors">
  <ng-container *ngIf="!previewBase64">{{ placeholder }}</ng-container>

  <img *ngIf="previewBase64" [src]="previewBase64" class="w-full h-full object-contain">

  <input type="file" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer" (change)="handleChange($event)">
</div>
